// extracted by mini-css-extract-plugin
export default {"toolbar":"auditTrail_toolbar__izVxt","section":"auditTrail_section__4F-Vs"};